module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui-steppers"
  }, [_c('div', {
    staticClass: "ui-steppers_header"
  }, [_vm._l((_vm.steps), function(name, index) {
    return [_c('div', {
      key: name,
      staticClass: "step-head-item"
    }, [_c('HeadStepItem', {
      attrs: {
        "active-step-name": _vm.steppersState.currentStepName,
        "step-name": name,
        "steps": _vm.steps,
        "invalidSteps": _vm.invalidSteps
      }
    })], 1)]
  })], 2), _c('div', {
    staticClass: "ui-steppers_content"
  }, [_vm._t("default", null, {
    "nextStep": function () {
      _vm.nextStep();
    },
    "prevStep": function () {
      _vm.prevStep();
    }
  })], 2), (_vm.isShowFooter) ? _c('div', {
    staticClass: "ui-steppers_footer"
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-342d75b2","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSteppers/AppSteppers.vue
// module id = ba1a56fedab08e0ef285
// module chunks = 89